import { Form, Field } from 'formik';
import styled from 'styled-components';
import {
  setBorder,
  setBorderWithCondition,
  setBorderWithConditionMobile,
  setMobileBorder,
} from '../utils/formInputHelper';
import { colors } from './Colors';

export interface FormLabelProps {
  $error?: string;
  $emptyvalue?: string;
  $position?: any;
  $identifier?: string;
}

export const PersonalDataForm = styled(Form)`
  margin-bottom: 0.5rem;
`;

interface FormInputProps {
  isDisabled?: boolean;
}

export const FormInput = styled(Field)<FormInputProps>`
  color: ${(props) =>
    props.isDisabled ? `${colors.gray8}` : `${colors.gray0}`};
  background-color: #fafafa;
  border-radius: ${(props) =>
    props.identifier === 'nie' ||
    props.position === 'upper' ||
    props.name === 'amount'
      ? setBorderWithCondition(
          props.name,
          props.position,
          props.identifier,
          props.error
        )
      : setBorder(props.name)};
  border: ${(props) =>
    props.error
      ? `1px solid ${colors.red5}`
      : `1px solid ${props.theme.colors.border}`};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  background-clip: padding-box;
  display: block;
  width: 100%;
  /* min-width: 180px; */
  height: calc(3.5rem + 2px);
  padding: 1rem 0.75rem;
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  text-transform: uppercase;
  outline: none;
  appearance: none;
  background-image: ${(props) =>
    props.component === 'select' &&
    `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`};
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;
  cursor: ${(props) => (props.component === 'select' ? 'pointer' : 'unset')};

  @media (max-width: 400px) {
    border-radius: ${(props) =>
      props.identifier === 'nie' ||
      props.position === 'upper' ||
      props.name === 'amount'
        ? setBorderWithConditionMobile(
            props.name,
            props.identifier,
            props.position
          )
        : setMobileBorder(props.name)};
  }
`;

export const CustomSelect = styled(FormInput)`
  text-overflow: ellipsis;
  padding-right: 80px;
  white-space: nowrap;
  border-radius: 6px;
`;

export interface FormInputRowProps {
  $minHeight?: string;
  $customWidth?: string;
}

export const FormInputRow = styled.div<FormInputRowProps>`
  display: flex;
  width: 100%;
  min-height: ${(props) => props.$minHeight};
  @media (max-width: 400px) {
    flex-direction: column;
  }
`;

export const FormInputLabel = styled.label<FormLabelProps>`
  transform: ${(props) =>
    props.$emptyvalue
      ? 'none'
      : 'scale(.85) translateY(-0.5rem) translateX(0.15rem)'};
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) =>
    props.$error ? `${colors.red5}` : `${colors.gray8}`}!important;
  opacity: 1 !important;
`;
export interface FormFloatingProps {
  $halfWidth?: string;
}

export const FormFloating = styled.div<FormFloatingProps>`
  position: relative;
  width: ${(props) => (props.$halfWidth ? '50%' : '100%')};
  flex: 0 1 auto;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const PersonalDataSelect = styled(FormFloating)`
  @media (max-width: 400px) {
    .css-835z8g-control {
      border-bottom-left-radius: 6px;
    }
  }
`;

export const FormOption = styled.option``;

export const ValidationError = styled.div`
  color: ${colors.red5};
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
`;
